export default __webpack_public_path__ + "static/p1-31d5455959bc8568ffe520f69c94297c.png";